// tslint:disable: no-console
import { ErrorHandler, Injectable } from '@angular/core';
import {
  ApplicationInsights,
  SeverityLevel as InSightsSeverity
} from '@microsoft/applicationinsights-web';
// tslint:disable-next-line: no-absolute-import
import { environment } from 'src/environments/environment';

const instrumentationKey = environment.applicationInsightsInstrumentationKey;

export enum SeverityLevel {
  Verbose = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  Critical = 4
}

@Injectable()
export class LoggerService implements ErrorHandler {
  private readonly areAppInsightsEnabled: boolean = !!instrumentationKey;
  private appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey
      }
    });
    this.appInsights.loadAppInsights();
  }

  /**
   * Logs message in Application insights
   * @param msg message to send
   */
  public log(msg: Error, severityLevel?: SeverityLevel): void {
    if (this.areAppInsightsEnabled) {
      this.appInsights.trackException({
        exception: msg,
        severityLevel: severityLevel || InSightsSeverity.Verbose
      });
    } else {
      console.log(msg);
    }
  }

  /**
   * Logs error message in Application insights
   *  @param msg message to send
   */
  public logError(msg: Error | string, severityLevel?: SeverityLevel): void {
    if (this.areAppInsightsEnabled) {
      if (msg instanceof Error) {
        this.appInsights.trackException({
          exception: msg,
          severityLevel: severityLevel || InSightsSeverity.Error
        });
      } else {
        this.appInsights.trackTrace({
          message: msg,
          severityLevel: severityLevel || InSightsSeverity.Error
        });
      }
    } else {
      console.error(msg);
    }
  }

  /**
   * Used to log unhandled errors that is implemented from `ErrorHandler`
   * @param error any
   */
  public handleError(error: Error): void {
    if (this.areAppInsightsEnabled) {
      this.appInsights.trackException({
        exception: error,
        severityLevel: InSightsSeverity.Critical
      });
    } else {
      console.error(error);
    }
  }
}
